import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loading from '@/shared/components/Loading';
import { paths } from '@/shared/helpers/paths';
import { NotificationPage } from './components/NotificationPage';

export const cadsAiNotificationBaseUrl = paths.CADS_AI.HOME.NOTIFICATION;

const Notifications = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path={cadsAiNotificationBaseUrl} component={NotificationPage} />
      </Switch>
    </Suspense>
  );
};

export default Notifications;
